import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useDocumentMeta } from '../lib/useDocumentMeta';
import legal from '../data/legalContent.json';

const resolve = (t) => {
  if (t !== '{{MEDIATEUR}}') return t;
  const m = legal.mediator;
  return m.name
    ? `Médiateur de la consommation : ${[m.name, m.address, m.website].filter(Boolean).join(' — ')}.`
    : "Coordonnées du médiateur de la consommation : en cours de désignation par SMT SERVICES. Elles seront publiées ici dès la signature de la convention de médiation.";
};

const Section = ({ s }) => (
  <section className="mt-10">
    <h2 className="text-base md:text-lg font-bold text-gray-900 mb-3">{s.title}</h2>
    {(s.paragraphs || []).map((p) => <p key={p} className="text-sm md:text-base text-gray-700 leading-relaxed mb-3" data-testid={p === '{{MEDIATEUR}}' ? 'legal-mediator' : undefined}>{resolve(p)}</p>)}
    {s.list && (
      <ul className="list-disc pl-5 space-y-2 text-sm md:text-base text-gray-700 leading-relaxed">
        {s.list.map((li) => <li key={li}>{li}</li>)}
      </ul>
    )}
  </section>
);

export default function LegalPage({ path }) {
  const page = legal.pages[path];
  useDocumentMeta({ title: page.metaTitle, description: page.description, path, ogType: 'website' });
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [path]);
  const other = Object.entries(legal.pages).find(([p]) => p !== path);
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-32 pb-20" data-testid="legal-page">
        <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 tracking-tight" data-testid="legal-title">{page.title}</h1>
        <p className="mt-3 text-xs text-gray-500">Dernière mise à jour : {legal.updated}</p>
        <p className="mt-8 text-sm md:text-base text-gray-700 leading-relaxed">{page.intro}</p>
        {page.sections.map((s) => <Section key={s.title} s={s} />)}
        <p className="mt-12 text-sm">
          <Link to={other[0]} className="text-[hsl(207,90%,44%)] underline" data-testid="legal-other-link">{other[1].title}</Link>
          {' · '}
          <Link to="/" className="text-[hsl(207,90%,44%)] underline" data-testid="legal-home-link">Retour à l'accueil</Link>
        </p>
      </main>
      <Footer />
    </div>
  );
}
